import {NgModule} from "@angular/core";
import {ClickOutDirective} from "./click.out.directive";

@NgModule({
	declarations: [ClickOutDirective],
	exports: [ClickOutDirective],
})
export class ClickOutModule {
}
